import React from 'react';
import { useSelector } from 'react-redux';

import AuthenticatedRoutes from './AuthenticatedRoutes';
import UnAuthenticatedRoutes from './UnAuthenticatedRoutes';

const RouteConfig = () => {
  const { token } = useSelector(state => state?.auth);
  return token ? <AuthenticatedRoutes /> : <UnAuthenticatedRoutes />;
};

export default RouteConfig;
